import { watch, type MaybeRefOrGetter, toValue } from 'vue';
import { extractMyNricBirthDateYmd, isMyNricIdType } from '@/shared/utils/myMalaysiaNric';

/**
 * MY NRIC(M01004) — Identification No. 앞 6자리로 Date of Birth 자동 입력
 */
export function useMyNricDateOfBirthAutoFill(options: {
    enabled: MaybeRefOrGetter<boolean>;
    idTypeCd: MaybeRefOrGetter<string | null | undefined>;
    identificationNo: MaybeRefOrGetter<string | null | undefined>;
    setDateOfBirth: (ymd: string) => void;
    canAutoFill?: MaybeRefOrGetter<boolean>;
}) {
    watch(
        () => [
            toValue(options.enabled),
            toValue(options.canAutoFill ?? true),
            toValue(options.idTypeCd),
            toValue(options.identificationNo),
        ] as const,
        ([enabled, canAutoFill, idTypeCd, identificationNo]) => {
            if (!enabled || !canAutoFill) return;
            if (!isMyNricIdType(idTypeCd)) return;
            const ymd = extractMyNricBirthDateYmd(identificationNo);
            if (!ymd) return;
            options.setDateOfBirth(ymd);
        },
    );
}
